<template>
    <div class="card card-default">
        <div class="card-header">Migrate from database</div>

        <div class="card-body">

            <div class="alert alert-success" v-if="form.successful">
                The migration will start in the background. You will be notified when it is done.
            </div>

            <form role="form" @submit.prevent="startMigration">

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">Database</label>

                    <div class="col-md-6">
                        <select name="database" id="database" class="form-control" v-model="form.database"
                                :class="{'is-invalid': form.errors.has('host')}">
                            <option v-for="db in databases" :value="db.name">{{ db.name }}</option>
                        </select>
                        <span class="invalid-feedback" v-show="form.errors.has('host')">
                                {{ form.errors.get('host') }}
                            </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">Team Name</label>

                    <div class="col-md-6">
                        <input type="text" class="form-control" name="team_name" v-model="form.team_name"
                               :class="{'is-invalid': form.errors.has('team_name')}">
                        <span class="invalid-feedback" v-show="form.errors.has('team_name')">
                            {{ form.errors.get('team_name') }}
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-4"></div>
                    <div class="col-md-6 ">
                        <input type="checkbox" name="with_project_management"
                               v-model="form.with_project_management" id="with_project_management"/>

                        <label class="col-form-label ml-1" for="with_project_management">
                            With Project Management
                        </label>
                    </div>
                </div>

                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button type="submit" class="btn btn-primary" :disabled="form.busy">

                            <span v-if="form.busy">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> starting
                            </span>

                            <span v-else>
                                Start migration
                            </span>
                        </button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>

<script>
    export default {
        name   : 'importer-new',
        props  : ['databases'],
        data() {
            return {
                form: new SparkForm({
                    database: null, name: null
                })
            }
        },
        created() {
            Bus.$on('databaseSet', () => {
                this.$emit('get-databases');
            });
        },
        methods: {
            checkConnection() {
                axios.get(route('legacy-migration.sql-server.status'))
                    .then(({data}) => this.databaseConnection = data.status);
            },
            startMigration() {
                Spark.post(route('legacy-migration.import.store'), this.form)
                    .then(({data}) => {
                        Bus.$emit('loadImports');
                    });
            }
        }
    }
</script>
